<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="PrintInvoices"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="copies"
        :label="'Copies'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        labelColsMd="3"
        contentColsMd="2"
      >
        <div
          class="input-group"
        >
          <ItpFormInput
            type="number"
            name="copies"
            v-model="payload.copies"
            required
          >
          </ItpFormInput>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="copies"
        :label="'Printer'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        labelColsMd="3"
        contentColsMd="9"
      >
        <UcPrinterSelector
          :item="payload"
          path="printer"
          clearable
        >
        </UcPrinterSelector>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Print'|pgettext('PrintInvoices|Submit')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-prrinter"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class PrintInvoices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_payload = new ComponentValueCache(this, "payload", "PrintInvoices.payload");
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
    default: "printInvoices",
  })
  formName!: string;

  @Watch('formName')
  onForm_name(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formName")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  payload!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'payload', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        payload: {
          copies: 1,
          printer: null,
          target: "remote",
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("PrintInvoices|Title", "Print Invoices"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3262_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3262, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_closeComponent_3264_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_2248226175642056_closeComponent_3264, alias=undefined
    return {
      result: {
        cancel: true,
      }
      ,
    }
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_3266_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_3266, alias=submit
    return {
      result: {
        ok: true,
        value: this.payload,
      }
      ,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3262: actions.CloseModalAction;
    evh_7315092382398562_close_3261: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3264: actions.CloseComponentAction;
    evh_2248226175642056_close_3263: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_3266: actions.CloseComponentAction;
    evh_1040167445267876_submit_3265: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_3268: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_3267: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3262 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3262_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3261 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3262,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3261],
      }
    );
    const act_2248226175642056_closeComponent_3264 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_2248226175642056_closeComponent_3264_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_close_3263 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3264,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3263],
      }
    );
    const act_1040167445267876_closeComponent_3266 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_3266_getActionArgs,
        displayName: "submit",
        events: [],
      }
    );
    const evh_1040167445267876_submit_3265 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_3266,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3265],
      }
    );
    const act_1419464017721962_closeComponent_3268 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3267 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_3268,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3267],
      }
    );
    return {
      act_7315092382398562_closeModal_3262,
      evh_7315092382398562_close_3261,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3264,
      evh_2248226175642056_close_3263,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_3266,
      evh_1040167445267876_submit_3265,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_3268,
      evh_1419464017721962_clickPreventStop_3267,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_closeComponent_3266,
    }
  }
}

Vue.component("PrintInvoices", PrintInvoices);

</script>